import { render, staticRenderFns } from "./HeroCard.vue?vue&type=template&id=d78d0ab4&"
import script from "./HeroCard.vue?vue&type=script&lang=js&"
export * from "./HeroCard.vue?vue&type=script&lang=js&"
import style0 from "./HeroCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports